import useClient from "@/hooks/global/useClient";
import React, { useState } from "react";
import { sanitizeHtml } from "@/utils/sanitizeHtml";

export default function Description({ desc = null }) {
  const [show, setShow] = useState(false);
  const text = parseTextFromHTML(desc || "");
  const { isClient } = useClient();

  return (
    isClient &&
    desc && (
      <div className=" mx-auto my-5 bg-slate-50 p-3 rounded-lg *:transition-all *:ease-linear *:duration-500 ease-linear flex justify-between gap-4">
        {show ? (
          <p
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(desc),
            }}
            className="duration-1000"
          />
        ) : (
          <p className="line-clamp-1">{text}</p>
        )}

        <svg
          onClick={() => setShow((prev) => !prev)}
          className={`w-5 h-5 shrink-0 transition duration-500 ${
            show && "-rotate-180"
          }`}
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </div>
    )
  );
}

function parseTextFromHTML(html) {
  return html.replace(/<[^>]*>/g, "").replace(/\&nbsp;/g, " ");
}

const htmlString = `<p class="my-2" style="text-align: center;"><span style="font-size: 16px;">اكتشف تشكيلة متنوعة من الجوالات والتابلت من المنيع التي تشمل أحدث الموديلات من&nbsp;<a href="https://www.almanea.sa/samsung-c-7558"><strong>سامسونج</strong></a>،&nbsp;هواوي،&nbsp;و<a href="https://www.almanea.sa/apple-c-7552"><strong>أبل</strong></a>.&nbsp;نقدم لك أحدث الابتكارات والتقنيات من هذه العلامات التجارية لتلبية جميع احتياجاتك الرقمية. من الأجهزة عالية الأداء إلى التقنيات المتقدمة، اختر من بين منتجاتنا لتجربة مميزة تجمع بين التصميم العصري والتكنولوجيا المتطورة. استعرض تشكيلتنا للحصول على أفضل الخيارات التي تناسب أسلوب حياتك وتفضيلاتك الشخصية.</span></p>`;

const parsedText = parseTextFromHTML(htmlString);
console.log(parsedText);
